import {
	ADMINGETCURRENCYMASTER_SUCCESS,
	ADMINGETCURRENCYMASTER_FAILED,
	RESET_ADMINGETCURRENCYMASTER,
	LOADING_ADMINGETCURRENCYMASTER,
	NETWORK_ERROR_ADMINGETCURRENCYMASTER
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETCURRENCYMASTER:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETCURRENCYMASTER_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETCURRENCYMASTER_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETCURRENCYMASTER:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETCURRENCYMASTER:
			return (state = initialState);
		default:
			return state;
	}
};
